<template>
  <div class="comment-user-profile mb-2">
    <div class="mb-2">
      <span
        class="comment-username text-truncate"
        :class="{ 'sumo-partner': commenterIsDealPartner }"
      >
        {{ comment.user.username }}
      </span>
      <a
        v-if="comment.user.has_plus || comment.user.has_briefcase"
        class="sumo-comment-badge"
        href="/plus/"
      />
      <span
        v-if="comment.purchased"
        class="sumo-bought-badge"
        data-testid="comment-user-has-bought"
      />
    </div>
    <div class="comment-user-meta">
      <span class="sumo-date">{{ parseFormatTime(comment.submit_date, 'MMM D YYYY h:mm a') }}</span>
      <span class="sumo-divider"> | </span>
      <span
        v-if="comment.user.deals_purchased"
        class="sumo-deal"
      >
        Deals Bought: {{ comment.user.deals_purchased }}
      </span>
      <span class="sumo-divider"> | </span>
      <span class="sumo-membersince">
        Member Since: {{ formatTime(comment.user.date_joined, 'MM/DD/YY') }}
      </span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(customParseFormat);

export default {
  name: 'PDPCommentUserProfile',
  props: {
    comment: {
      type: Object,
      default: () => ({}),
    },
    commenterIsDealPartner: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    parseFormatTime(date, format = 'MMM DD, YYYY, h:mm a') {
      if (!date) return '';

      if (typeof date === 'number') {
        return dayjs.unix(date).format(format);
      }

      // Dayjs doesn't like .
      const parsedDate = date.replace(/\./g, '');
      const formattedDate = dayjs(parsedDate).format(format);

      return ((formattedDate === 'Invalid Date') ? 'Recently Commented' : formattedDate);
    },
    formatTime(date, format) {
      return dayjs(date).format(format);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~/styles/utils/breakpoints';

  .comment-user-profile {
    margin-top: -2px;
    font-size: 1rem;
  }

  .sumo-partner::after {
    content: 'Creator';
    background: #5ebdc0;
    display: inline-block;
    padding: 0.2rem 0.3rem;
    margin-left: 0.4rem;
    border-radius: 3px;
    color: #fff;
    line-height: 1;
    font-size: 0.7rem;
    font-weight: 500;
    vertical-align: 0.15em;
  }

  .sumo-bought-badge {
    display: inline-block;
    min-width: 1.8rem;
    min-height: 0.8rem;
    margin-left: 0.3rem;
    background-image: url(../../../../static/images/discussions/as-check.svg);
    background-repeat: no-repeat;
    background-position-y: center;
    vertical-align: 0.1em;
  }

  .sumo-comment-badge {
    display: inline-block;
    min-height: 0.94rem;
    min-width: 4.1rem;
    padding: 0.3em 0.7em;
    border-radius: 3px;
    vertical-align: -0.15rem;
    background-image: url(../../../../static/images/discussions/as-plus-icon.svg);
    background-size: contain;
    cursor: pointer;
  }

  .sumo-bought-badge::after {
    color: #000;
    margin-left: 1.4rem;
    font-size: 0.6rem;
    font-weight: 600;
    content: 'Verified Purchaser';
  }

  .comment-username {
    font-size: 1rem;
    color: #272727;
    font-weight: 700;
    display: block;
  }

  .comment-user-meta {
    color: #ccc;
    font-size: 0.7em;
    line-height: 1.7;
    font-weight: 300;
  }

  @include media-breakpoint-down(md) {
    .comment-username {
      font-size: 0.9rem;
    }

    .comment-user-meta {
      font-size: 0.6rem;
    }

    .sumo-divider {
      opacity: 0;
    }
  }

</style>
